<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">

            <v-data-table :headers="headers" :items="template_details_list" class="elevation-1 mytable" dense
                :search="search">

                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Course Template Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <div class="d-flex justify-center mb-8 mt-4">
                        <v-card class="summary-card elevation-6">

                            <div class="summary-header">
                                <v-icon color="white" class="mr-2">mdi-file-document-outline</v-icon>
                                Template Summary
                            </div>

                            <div class="summary-content">

                                <div class="summary-box">
                                    <div class="summary-label">
                                        Template Name
                                    </div>

                                    <div class="summary-value text-truncate">
                                        {{ template_name }}
                                    </div>
                                </div>

                                <div class="summary-divider"></div>

                                <div class="summary-box">
                                    <div class="summary-label">
                                        Total Credits
                                    </div>

                                    <div class="summary-value credit-text">
                                        {{ template_total_credits }}
                                    </div>
                                </div>

                            </div>
                        </v-card>
                    </div>
                    <v-row dense align="center">

                        <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>

                        <v-col class="mr-8" sm="6" md="5" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details />
                        </v-col>

                        <v-dialog v-model="dialog" max-width="400px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" small v-on="on">
                                    Add Template Details
                                </v-btn>
                            </template>

                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text class="pb-2 mt-2 pl-7 pr-7">
                                        <v-row dense align="center" justify="center">

                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-autocomplete dense outlined :items="subject_head_list"
                                                    item-text="name" item-value="id" v-model="subject_head"
                                                    label="Select Subject Head"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-autocomplete dense outlined :items="selection_type_list"
                                                    item-text="name" item-value="id" v-model="selection_type"
                                                    label="Select Selection Type"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-autocomplete dense outlined :items="course_rule_list"
                                                    item-text="name" item-value="id" v-model="course_rule"
                                                    label="Select Course Rule"></v-autocomplete>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-text-field label="Enter Credit" v-model="total_credits" outlined
                                                    dense type="number" />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field label="Enter Bucket Number" v-model="bucket_no" outlined :disabled="isCPRule"
                                                    dense type="number" />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field label="Enter Number Of Electives" :disabled="isCPRule"
                                                    v-model="no_of_electives" outlined dense type="number" />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field label="Enter Elective Pick Up Count" :disabled="isCPRule"
                                                    v-model="pick_up_count" outlined dense type="number" />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-checkbox dense v-model="is_auto_allot" color="success"
                                                    label="Is Auto Allotment" />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-checkbox dense v-model="is_choice_based" color="success"
                                                    label="Is Choice Based" />
                                            </v-col>

                                            <v-col cols="12">
                                                <v-checkbox dense v-model="is_optional" color="success"
                                                    label="Is Optional" />
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-card-actions class="justify-center pt-0">
                                        <v-btn class="button" @click="close()" :disabled="!valid">
                                            Cancel
                                        </v-btn>

                                        <v-btn color="primary button" @click="save" :disabled="!valid">
                                            {{ editedIndex === -1 ? 'Save' : 'Update' }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>

                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>

                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.template_details="{ item }">
                    <div class="align-center detail-btn" @click="viewDetails(item)">
                        <v-icon color="primary" class="mr-1">
                            mdi-arrow-right-bold-box
                        </v-icon>
                    </div>

                </template>
                <template v-slot:item.is_auto_allot="{ item }">
                    <div class="text-center">
                        <v-checkbox
                            :input-value="item.is_auto_allot"
                            readonly
                            dense
                            hide-details
                            color="success"
                            class="ma-0 pa-0 d-flex justify-center"
                        ></v-checkbox>
                    </div>
                </template>

                <template v-slot:item.is_choice_based="{ item }">
                    <div class="text-center">
                        <v-checkbox
                            :input-value="item.is_choice_based"
                            readonly
                            dense
                            hide-details
                            color="success"
                            class="ma-0 pa-0 d-flex justify-center"
                        ></v-checkbox>
                    </div>
                </template>

                <template v-slot:item.is_optional="{ item }">
                    <div class="text-center">
                        <v-checkbox
                            :input-value="item.is_optional"
                            readonly
                            dense
                            hide-details
                            color="success"
                            class="ma-0 pa-0 d-flex justify-center"
                        ></v-checkbox>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        snackbar_msg: "",
        loader: false,
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        template_id: "",
        template: "",
        subject_head: "",
        selection_type: "",
        course_rule: "",
        total_credits: "",
        bucket_no: "",
        pick_up_count: "",
        no_of_electives: "",
        credit: "",
        template_name: "",
        template_total_credits: "",
        is_auto_allot:false,
        is_choice_based:false,
        is_optional:false,
        headers: [
            {
                text: "Sr No",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "Subject Head",
                align: "center",
                sortable: false,
                value: "course_head_name",
            },
            {
                text: "Selection Type",
                align: "center",
                sortable: false,
                value: "selection_type_name",
            },
            {
                text: "Course Rule",
                align: "center",
                sortable: false,
                value: "course_rule",
            },
            {
                text: "Credits",
                align: "center",
                sortable: false,
                value: "total_credits",
            },
            {
                text: "Bucket Number",
                align: "center",
                sortable: false,
                value: "bucket_number",
            },
            {
                text: "No. Of Electives",
                align: "center",
                sortable: false,
                value: "no_of_electives",
            },
            {
                text: "Elective Pick Up Count",
                align: "center",
                sortable: false,
                value: "elective_pickup_count",
            },
            {
                text: "Is Auto Allotment",
                align: "center",
                sortable: false,
                value: "is_auto_allot",
            },
            {
                text: "Is Choice Based",
                align: "center",
                sortable: false,
                value: "is_choice_based",
            },
            {
                text: "Is Optional",
                align: "center",
                sortable: false,
                value: "is_optional",
            },
            {
                text: "Actions",
                value: "action",
                sortable: false
            },
        ],

        template_details_list: [],
        subject_head_list: [],
        selection_type_list: [],
        course_rule_list: [],
        editedIndex: -1,
        editedItem: {
            id: "",
            template: "",
            subject_head: "",
            selection_type: "",
            course_rule: "",
            total_credits: "",
            bucket_no: "",
            pick_up_count: "",
            credit: "",
        },

        defaultItem: {
            id: "",
            template: "",
            subject_head: "",
            selection_type: "",
            course_rule: "",
            total_credits: "",
            bucket_no: "",
            pick_up_count: "",
            credit: "",
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Add Template Details" : "Edit Template Details";
        },
        filteredRuleList() {
            if (!this.search) return this.template_details_list;

            const txt = this.search.toLowerCase();

            return this.template_details_list.filter(item => (item.name || "").toLowerCase().includes(txt)
            );
        },
        isElectiveRule() {
            const selectedRule = this.course_rule_list.find(
                item => item.id == this.course_rule
            );

            return selectedRule &&
                selectedRule.name &&
                selectedRule.name.toLowerCase() === "el";
        },
        isCPRule() {
            const selectedRule = this.course_rule_list.find(
                item => item.id == this.course_rule
            );

            return (
                selectedRule &&
                selectedRule.name &&
                selectedRule.name.toLowerCase() === "cp"
            );
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        course_rule(val) {
            if (!val || !this.course_rule_list.length) return;
            const selectedRule = this.course_rule_list.find(
                item => item.id == val
            );

            const ruleName = selectedRule.name.toLowerCase();

            if (ruleName === "cp") {
                this.bucket_no = 0;
                this.no_of_electives = 0;
                this.pick_up_count = 0;
            }

            if (ruleName === "el" && this.editedIndex === -1) {
                this.bucket_no = "";
                this.no_of_electives = "";
                this.pick_up_count = "";
            }
        }
    },

    methods: {
        downloadFile() {
            this.loader = true;

            const excelData = this.filteredRuleList.map((item, index) => ({
                "S.No": index + 1,
                "Subject Head": item.course_head_name,
                "Selection Type": item.selection_type_name,
                "Course Rule": item.course_rule,
                "Credits": item.total_credits,
                "Bucket Number": item.bucket_no,
                "Number Of Electives": item.no_of_electives,
                "Elective Pick Up Count": item.elective_pickup_count,
                "Is Auto Allotment": item.is_auto_allot,
                "Is Choice Based": item.is_choice_based,
                "Is Optional": item.is_optional
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Template Details");
            XLSX.writeFile(workbook, "TemplateDetails.xlsx");
            this.loader = false;
        },

        editItem(item) {
            this.editedIndex = this.template_details_list.indexOf(item);

            this.editedItem = item;

            this.subject_head = item.course_head_id;
            this.selection_type = item.selection_type_id;
            this.course_rule = item.course_rule_id;

            this.total_credits = item.total_credits;
            this.bucket_no = item.bucket_number;
            this.pick_up_count = item.elective_pickup_count;
            this.no_of_electives = item.no_of_electives;

            this.is_auto_allot = item.is_auto_allot;
            this.is_choice_based = item.is_choice_based;
            this.is_optional = item.is_optional;

            this.dialog = true;
        },


        onLoad() {
            if (!this.template_id) {
                this.showSnackbar("#b71c1c", "Template Not Found")
                return
            }
            // this.overlay = true;
            const data = {
                template_id: this.template_id
            }
            axios
                .post("/admission/getTemplateDetails", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.template_details_list = [];
                        this.template_name = res.data.template_name;
                        this.template_total_credits = res.data.total_credits;

                        if (res.data.template_details_list &&
                            res.data.template_details_list.length > 0) {

                            this.template_details_list =
                                res.data.template_details_list.map((item, index) => ({
                                    ...item,
                                    srno: index + 1
                                }));
                        } else {
                            this.showSnackbar("#b71c1c", "No Template Details Found");
                        }
                        this.subject_head_list = res.data.subject_head_list;
                        this.selection_type_list = res.data.selection_type_list;
                        this.course_rule_list = res.data.course_rule_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            this.subject_head = "";
            this.selection_type = "";
            this.course_rule = "";
            this.total_credits = "";
            this.bucket_no = "";
            this.pick_up_count = "";
            this.credit = "";
            this.no_of_electives = "";
            this.is_auto_allot = false;
            this.is_choice_based = false;
            this.is_optional = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (!this.isValidated()) {
                return;
            }

            const payload = {
                template: this.template_id,
                subject_head: this.subject_head,
                selection_type: this.selection_type,
                course_rule: this.course_rule,
                total_credits: this.total_credits,
                bucket_no: this.bucket_no,
                pick_up_count: this.pick_up_count,
                no_of_electives: this.no_of_electives,
                is_auto_allot: this.is_auto_allot,
                is_choice_based: this.is_choice_based,
                is_optional: this.is_optional
            };

            this.overlay = true;

            if (this.editedIndex > -1) {

                payload.id = this.editedItem.id;

                axios
                    .post("/admission/editTemplateDetails", payload)
                    .then((res) => {

                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Template Details Updated Successfully...");
                            this.close();
                            this.onLoad();
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg || "Template Details Already Present...");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            }
            else {
                axios
                    .post("/admission/saveTemplateDetails", payload)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Template Details Added Successfully...");
                            this.close();
                            this.onLoad();
                        } else if (res.data.code == "duplicate") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg || "Template Details Already Present...");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            }
        },

        isValidated() {

            if (!this.subject_head) {
                this.showSnackbar("#b71c1c", "Enter Subject Head...");
                return false;
            }

            if (!this.selection_type) {
                this.showSnackbar("#b71c1c", "Enter Selection Type...");
                return false;
            }

            if (!this.course_rule) {
                this.showSnackbar("#b71c1c", "Enter Course Rule...");
                return false;
            }

            if (!this.total_credits) {
                this.showSnackbar("#b71c1c", "Enter Total Credits...");
                return false;
            }

            if (this.isElectiveRule) {

                if (
                    this.bucket_no === null ||
                    this.bucket_no === undefined ||
                    this.bucket_no === ""
                ) {
                    this.showSnackbar("#b71c1c", "Enter Bucket Number...");
                    return false;
                }

                if (
                    this.no_of_electives === null ||
                    this.no_of_electives === undefined ||
                    this.no_of_electives === ""
                ) {
                    this.showSnackbar("#b71c1c", "Enter Number Of Electives...");
                    return false;
                }

                if (
                    this.pick_up_count === null ||
                    this.pick_up_count === undefined ||
                    this.pick_up_count === ""
                ) {
                    this.showSnackbar("#b71c1c", "Enter Elective Pick Up Count...");
                    return false;
                }
            }

            if (this.pick_up_count && this.no_of_electives && Number(this.pick_up_count) > Number(this.no_of_electives)) {
                this.showSnackbar("#b71c1c", "Elective Pick Up Count must be less than or equal to Number Of Electives...");
                return false;
            }

            return true;
        },

        deleteItem(item) {
            if (confirm("Are you sure you want to delete this Template Details?")) {
                const data = {
                    id: item.id
                };
                axios
                    .post("/admission/deleteTemplateDetails", data)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Template Details Deleted Successfully...");
                            this.onLoad();
                        }if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.onLoad();
                        }
                        else {
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
            this.close();
        },

    },

    mounted() {
        this.template_id = localStorage.getItem('template_id');
        this.onLoad();
    }
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mytable /deep/ td {
    padding: 12px 10px !important;
    font-size: 13px;
    vertical-align: middle;
}

.mytable /deep/ th {
    padding: 14px 10px !important;
    font-size: 13px;
}

.summary-card {
    width: 480px;
    border-radius: 18px;
    overflow: hidden;
    background: #ffffff;
    border: none !important;
}

.summary-header {
    background: linear-gradient(135deg, #1e3c72, #2a5298);
    color: white;
    font-size: 16px;
    font-weight: 600;
    padding: 14px 18px;
    display: flex;
    align-items: center;
    letter-spacing: 0.5px;
}

.summary-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background: #f8fafc;
}

.summary-box {
    flex: 1;
    text-align: center;
}

.summary-label {
    font-size: 13px;
    font-weight: 600;
    color: #546e7a;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.summary-value {
    font-size: 18px;
    font-weight: bold;
    color: #1e293b;
}

.credit-text {
    color: #0b0d0c;
    font-size: 22px;
}

.summary-divider {
    width: 1px;
    height: 55px;
    background: #cfd8dc;
}
</style>